import React from 'react';
import {Link} from 'react-router-dom'

const Home = () => {
    return (
        <div className="App">
        
      <header className="App-header">
        {/* <img src={sacchi} className="App-background" alt="logo" 
        {/* // width='100%'/> */}

        <p className='main-p' >
         Find The Healthy Receipts That You Need!
        </p>

        {/* <Link
          className="App-link"
          to="/list"
         
        >
          Learn More 
        </Link> */}
        <Link   className="App-link" to='/vitamins'>Discover Nutrients</Link>
        </header>
            
        </div>
    )
}

export default Home
